export var getDay = (d) => {
    return parseInt(d.split('-')[2], 10);
}

export var getMonth = (d) => {
    return parseInt(d.split('-')[1], 10);
}